import debounce from 'lodash/debounce'

const preventDoubleClick = (handler: (...args: unknown[]) => void) =>
  debounce(handler, 500, {leading: true, trailing: false})

export default preventDoubleClick
